import { AnyAction, Reducer } from 'redux';
import cloneDeep from 'lodash/cloneDeep';
import { App } from '@ps20-frontend/frontend-models';
import { mergeState } from '@ps20-frontend/migrations';
import {
  GlobalAction,
  GlobalActions,
  ReplaceState,
  WrappedSavedStates,
  WrappedSavedStatesLoaded,
} from '@ps20-frontend/shop-integration-redux';
import { Feature } from '@ps20/bff-models';
import { IAppState } from './localStore';
import { isSdwSession } from './selectors/transientState.selector';

export const rootReducer =
  (reducer: Reducer) =>
  (state: IAppState, action: AnyAction): IAppState => {
    // NOSONAR
    switch (action.type) {
      case GlobalActions.SAVED_STATES_LOADED: {
        const newState = cloneDeep(state);
        const actionPayload: WrappedSavedStates = (action as GlobalAction<WrappedSavedStatesLoaded>)
          .payload.savedStatesLoaded;
        const loadedAppState = actionPayload.find(loadedState => loadedState.appId === App.SHOP);

        if (loadedAppState != null) {
          const loadedShopState = { ...loadedAppState.state };
          delete loadedShopState.canNavigate;
          const migratedState = mergeState(newState, loadedShopState);
          if (
            isSdwSession(state) &&
            state.transientState.featureToggles[Feature.VTNR_AMISNOW] &&
            loadedAppState.state.accountManager
          ) {
            migratedState.transientState.loadVorvertraege.vermittlernummer =
              loadedAppState.state.accountManager;
          }
          return migratedState;
        } else {
          return state;
        }
      }
      case GlobalActions.REPLACE_STATE: {
        const actionPayload: ReplaceState<IAppState> = action.payload;
        if (actionPayload.appId === App.SHOP) {
          return actionPayload.appState;
        }
        return state;
      }
      default:
        return reducer(state, action);
    }
  };
